'use strict';

function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.decoding = 'async';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Boss asset unavailable: ${url}`));
    image.src = url;
  });
}

class BossAssetService {
  constructor() {
    this.images = {};
    this.manifest = null;
    this.animalImages = {};
    this.animalLoading = {};
    this.ready = false;
    this.loading = null;
  }

  load() {
    if (this.loading) return this.loading;
    this.loading = fetch('/assets/boss/manifest.json', { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) throw new Error('Boss assets unavailable');
        return response.json();
      })
      .then((manifest) => {
        this.manifest = manifest;
        return Promise.all(
          ['fighter', 'rabbit', 'carrot'].map((key) => [key, manifest[key]]).filter(([, url]) => url).map(([key, url]) => (
          loadImage(url).then((image) => { this.images[key] = image; })
          ))
        );
      })
      .then(() => {
        this.ready = true;
        return { ...this.images, ready: true };
      })
      .catch(() => ({ fighter: null, rabbit: null, carrot: null, ready: false }));
    return this.loading;
  }

  get(name) {
    return this.images[name] || null;
  }

  preloadAnimal(level) {
    const key = String(Math.max(1, Math.min(99, Math.floor(Number(level) || 1))));
    if (this.animalImages[key]) return Promise.resolve(this.animalImages[key]);
    if (this.animalLoading[key]) return this.animalLoading[key];
    this.animalLoading[key] = this.load()
      .then(() => {
        const url = this.manifest && this.manifest.animals && this.manifest.animals[key];
        if (!url) return null;
        return loadImage(url).then((image) => {
          this.animalImages[key] = image;
          return image;
        });
      })
      .catch(() => null);
    return this.animalLoading[key];
  }

  getAnimal(level) {
    const key = String(Math.max(1, Math.min(99, Math.floor(Number(level) || 1))));
    return this.animalImages[key] || null;
  }
}

module.exports = BossAssetService;
